import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import routes from 'constants/router'
import { useFindMatchedRoutes } from 'utils/findMatchedRoutes'

const Seo = () => {
  const matchedRoutes = useFindMatchedRoutes(routes)
  const { t } = useTranslation()

  const title = useMemo(
    () => matchedRoutes.map(({ label_key }) => t(label_key)).join(' — '),
    [matchedRoutes, t],
  )

  return (
    <Helmet defer={false}>
      <title>{title}</title>
    </Helmet>
  )
}

export default Seo
